import React, { useState } from 'react';
import paintOrderService from '../../utils/paint-orders';
import { getCurrentCapacity } from '../../pages/paintCapacityPage/paintCapacityTools';
import './paintOrder.css';

const PaintOrdersAddForm = (props) => {
  const [paintOrders, setPaintOrders] = useState([]);

  const [errors, setErrors] = useState({});
  const [input, setInput] = useState({
    date: '',
    type: '',
    liters: '',
    orderNumber: '',
    observations: ''
  });

  const TYPES = [
    {_id: 1,  name: 'HOGAR Y OBRA', capacity: 600, decrementPerHour: 75 },
    {_id: 2, name: 'REVESTIMIENTO', capacity: 450, decrementPerHour: 56.25 },
    {_id: 3, name: 'INDUSTRIA', capacity: 250, decrementPerHour: 31.25 }
  ];

  const handleKeyUp = (e) => {
    const allErrors = validateForm(input);
    // so that not all errors are displayed at the same time the specific error is destructured
    const err = allErrors[e.target.name];
    if (err) {
        setErrors({ ...errors, [e.target.name]: err });
    } else {
        // but if that field has no error it is removed from the errors and the others are displayed
        const rest = { ...errors };
        delete rest[e.target.name];
        setErrors(rest);
    }
  };

   const handleChange = (e) => {
        setInput({ ...input, [e.target.name]: e.target.value });
    };

  /**
   * Validates if all the fields are included
   */
  const validateForm = () => {
    const errors = {};

    if (!input.date) {
        errors.date = 'La fecha es requerida';
    }

    if (!input.type) {
        errors.type = 'El tipo de pintura es requerido';
    }

    if (!input.liters) {
        errors.liters = 'La cantidad de litros es requerida';
    }

    if (input.observations.length > 200) {
        errors.observations = 'Las observaciones no pueden tener mas de 200 caracteres';
    }

    if (input.liters < 0) {
        errors.liters = 'La cantidad de litros no puede ser menor a 0';
    }

    if (input.type === 'select-type') {
        errors.type = 'El tipo de pintura es requerido';
    }

    return errors;
  };

  // Validate the max capacity when adding a new entry
  const validateMaxCapacity = async () => {
    const errors = {};
    if (input.date && input.type) {
      // Get the DB and current input orders
      const ordersPlanned = await lookupPaintOrdersByDate(input.date);
      const totalForTheDayPlanned = getTotalByType(input.type, ordersPlanned);
      const currentTotalForm = getTotalByType(input.type, paintOrders);

      // Get the capacity
      const paintTypeConfig = TYPES.filter(type => type.name === input.type);
      const capacityForType = paintTypeConfig.length ? paintTypeConfig[0].capacity : 0;

      // Plan and validate
      const litersToPlan = totalForTheDayPlanned + Number(currentTotalForm) + Number(input.liters);
      if (litersToPlan >= capacityForType) {
        errors.general = `Se esta superando el limite para este dia de ${input.type}. Maximo disponible para el ${input.date}: ${capacityForType - totalForTheDayPlanned - currentTotalForm} litros`
      }
    }
    return errors;
   }


   const validateMaxCapacityForToday = async () => {
    const errors = {};
    const today = new Date().toISOString().split('T')[0];

    // We check if is today
    if (input.date && input.type && input.date === today) {
        const ordersPlanned = await lookupPaintOrdersByDate(input.date);
        const totalForTheDayPlanned = getTotalByType(input.type, ordersPlanned);

        // Get the current capacity for the type
        const paintTypeConfig = TYPES.filter(type => type.name === input.type);
        const capacityForType = paintTypeConfig.length ? paintTypeConfig[0].capacity : 0;
        const todayCapacityRemaining = getCurrentCapacity(capacityForType, totalForTheDayPlanned, paintTypeConfig[0].decrementPerHour);

        console.log('Today capacity remaining: ', todayCapacityRemaining);

        const litersToPlan = Number(input.liters);

        if (litersToPlan >= todayCapacityRemaining) {
          errors.general = `Se esta superando el limite para este dia de ${input.type}. Queda disponible para hoy ${input.date}: ${todayCapacityRemaining} litros`
        }
    }
    return errors;
   }

   const getTotalByType = (type, orders) => {
    return orders.reduce((total, order) => {
      if (order.paintType === type) {
        return total + Number(order.liters);
      }
      return total;
    }
    , 0);
  };
   // Search the paint orders by date
  const lookupPaintOrdersByDate = async (date) => {
   const { data: orders } = await paintOrderService.getPaintOrdersByDate({ date })
   return orders;
  };

  /**
   * Adds the product to return with the correct model
   */
  const addPaintOrder = async () => {
    const validationResult = validateForm();
    const validateCapacity = await validateMaxCapacity();
    const validateTodayCapacity = await validateMaxCapacityForToday();
    if (
      Object.keys(validationResult).length === 0 &&
      Object.keys(validateCapacity).length === 0 &&
      Object.keys(validateTodayCapacity).length === 0
    ) {
      const order = {
        date: new Date(input.date).toISOString(),
        liters: input.liters,
        paintType: input.type,
        orderNumber: input.orderNumber || '',
        observations: input.observations || '',
        status: 'PENDIENTE',
        user: props.user._id,
      };
      paintOrders.push(order);
      setPaintOrders(paintOrders);

      // Create a new array to trigger re render :)
      props.setPaintOrders([...paintOrders]);

      // Save to the local storage
      resetForm();
    } else {
      setErrors({
        ...validationResult,
        ...validateCapacity,
        ...validateTodayCapacity,
      });
    }
  };

  /**
   * Resets the form with empty values
   */
  const resetForm = () => {
      input.date = '';
      input.type = '';
      input.liters = '';
      input.orderNumber = '';
      setErrors({});
  };

  const generateSelector = (name, data) => {
      const value = 'name';
      const options = [
          <option key={`key-select-${name}`} value={`select-${name}`}>
              {' '}
              Seleccionar
          </option>
      ];
      if (data && data.length > 0) {
          data.forEach((option) => {
              options.push(
                  <option
                      key={`key-${option._id}`}
                      value={option[value]}
                      data-id={option._id}
                  >
                      {option[value]}
                  </option>
              );
          });
      }

      return (
          <select
              id={name}
              className="form-control"
              onChange={handleChange}
              onKeyUp={handleKeyUp}
              name={name}
              value={input[name] || ''}
          >
              {options}
          </select>
      );
  };

  return (
    <div className="products-section">
      <div className="form-group receipt-data">
        <div className="date-picker">
          <label>Fecha</label>
          <input
            type="date"
            name="date"
            className="form-control"
            placeholder="Fecha"
            value={input.date}
            onChange={handleChange}
            onKeyUp={handleKeyUp}
          />
          <p className="error-login">{errors.date}</p>
        </div>
        <div>
          <label>Tipo de Pintura</label>
          {generateSelector('type', TYPES)}
          <p className="error-login">{errors.TYPE}</p>
        </div>
        <div>
          <label>Cantidad de Litros</label>
          <input
            type="number"
            min={0}
            step={1}
            name="liters"
            className="form-control"
            placeholder="Litros"
            value={input.liters}
            onChange={handleChange}
            onKeyUp={handleKeyUp}
          />
          <p className="error-login">{errors.liters}</p>
        </div>
        <div>
          <label>Numero Orden (Opcional)</label>
          <input
            type="text"
            name="orderNumber"
            className="form-control"
            placeholder="Numero Orden"
            value={input.orderNumber}
            onChange={handleChange}
            onKeyUp={handleKeyUp}
          />
          <p className="error-login">{errors.orderNumber}</p>
        </div>
        </div>
        <div className="form-group observations">
              <label>Observaciones (Opcional)</label>
              <textarea
                name="observations"
                value={input.observations}
                placeholder="Observaciones"
                onChange={handleChange}
                onKeyUp={handleKeyUp}
                className="form-control"
                aria-label="Observaciones"
              />
              <p className="error-login">{errors.observations}</p>
        </div>
        <div className="form-group">
          <div className="btn-add">
            <button
              type="button"
              className="btn btn-dark btn-block"
              onClick={async () => await addPaintOrder()}
            >
              Agregar Orden
            </button>
          </div>
          <p className="error-login">{errors.general}</p>
        </div>
    </div>
  );
};

export default PaintOrdersAddForm;
